import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';

class Step8 extends Component {
    render() {
        return (

            <div className="card card-body">

                <div className="form-group">
                    <div className="row">
                        <div className='col-sm-12 h5'>POWER SUPPLY INSPECTION</div>

                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <ThreeOptions
                                name="powerFusedRating"
                                label="Fused as per Manufacturer’s Marked Rating of The System"
                            />
                        </div>
                        <div className="col-sm-12 ">
                            <ThreeOptions
                                name="powerAdequate"
                                label="Adequate to Meet The Requirements of The System"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Step8;



// WEBPACK FOOTER //
// ./src/components/Step8.js